<template>
  <div class="homePage">
      <div>
        <HomePage v-if="active == 0"></HomePage>
        <taskList v-if="active == 1"></taskList>
        <UserInfo v-if="active == 3"></UserInfo>
      </div>
      <van-tabbar v-model="active" style="z-index:999">
        <van-tabbar-item icon="home-o">首页</van-tabbar-item>
        <van-tabbar-item icon="bookmark">我的任务</van-tabbar-item>
        <van-tabbar-item icon="todo-list" @click="goToWoList">工单列表</van-tabbar-item>
        <van-tabbar-item icon="manager-o" >我</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import WoList from './wo/index.vue'
import TaskList from './myTask/index.vue'
import UserInfo from '../my/index.vue'
import Vue from 'vue';
import { Tabbar,TabbarItem } from 'vant';
import {router}  from '../../router'
import HomePage from '../bussComponents/homePage'

Vue.use(Tabbar);
Vue.use(TabbarItem);

export default {
  components: {
    Tabbar, 
    TabbarItem,
    TaskList,
    WoList,
    UserInfo,
    HomePage
  },
  computed: {
  },
  data() {
    return {
      active: 0,
    };
  },
  mounted(){

  },
  methods: {
    logout(){
    },
    goHome(){
      this.active = -1;
    },
    goToWoList(){
      router.push('/woList')
    }
  }
};
</script>

<style lang="less">
</style>
